<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid manage-suppliers">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Suppliers</h4>
            <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
              <router-link :to="{ name: 'ManageSuppliers' }" class="d-inline" style="font-weight: normal;">
                Supplier List
              </router-link>
            </div>
            <div class="alert alert-warning mb-0" v-if="addedSupplierId">
              Supplier added successfully
            </div>
            <router-link to="/manage-suppliers/add-supplier">
              <button class="btn btn-primary mt-3">Add Supplier</button>
            </router-link>
            <hr />
            <div class="d-flex justify-content-between">
              <div class="d-flex ms-2" style="align-items: center;">
                <div>
                  <label class="form-label m-0">Show </label>
                </div>
                <div class="ms-2 ml-1 mr-1">
                  <select class="form-control form-select-sm" v-model.number="perPage" @change="getSuppliers">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div class="ms-2"><label class="m-0">entries</label></div>
              </div>

              <div class="col-md-4">
                <input type="search" class="form-control" placeholder="Search" v-model="searchTerm" id="searchBar" @input="searchSuppliers" />
              </div>
            </div>

            <div class="table-responsive mt-3">
              <table class="table table-bordered border-light">
                <thead>
                  <tr>
                    <th scope="col"  style="cursor: pointer">
                      <span>ID</span>
                    </th>
                    <th scope="col" @click="sortSuppliers()" style="cursor: pointer">
                      <span>Suppliers</span> <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
                    </th>
                    <th scope="col" @click="sortSuppliers()">
                      Amway <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
                    </th>
                    <th scope="col" @click="sortSuppliers()">
                      Exclude Dynamic Vendor <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
                    </th>
                    <th scope="col">Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading === true">
                    <div>
                      <div class="centered">
                        <a-spin />
                      </div>
                    </div>
                  </tr>

                  <tr v-for="supplier in this.allSuppliers.Result" :key="supplier.id" v-else>
                    <td>
                      {{ supplier.id }}
                    </td>
                    <td>
                      {{ supplier.name }}
                    </td>
                    <td>{{ supplier.amway === true ? 'Yes' : 'No' }}</td>
                    <td>
                      {{ supplier.excdynamicvendor === 1 ? 'Yes' : 'No' }}
                    </td>
                    <td>
                      <router-link
                        :to="{
                          name: 'EditSupplier',
                          params: {
                            Id: supplier.id,
                          },
                        }"
                      >
                        <button type="button" class="btn btn-sm btn-primary">
                          Edit
                        </button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between">
                <div>
                  <span>Showing {{ this.allSuppliers.selectedRecordCount }} of {{ this.allSuppliers.totalRecords }} entries </span>
                </div>
                <div class="" v-if="this.allSuppliers.Result">
                  <pagination
                    :data="this.allSuppliers.Result"
                    :totalPages="Math.ceil(this.allSuppliers.totalRecords / perPage)"
                    :total="this.allSuppliers.totalRecords"
                    :perPage="perPage"
                    :currentPage="currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import divvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';
import AddSuppliersForm from './AddSuppliersForm.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'ManageSuppliers',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    addSuppliersForm: AddSuppliersForm,
    pagination: Pagination,
  },
  data() {
    return {
      loading: false,
      searchTerm: '',
      currentPage: 1,
      perPage: 10,
      sortField: '[NAME]',
      sortOrder: 'ASC',
    };
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'addSupplier',
        activeMenu: this.activeMenu ? this.activeMenu : 'productandsuppliers',
      });
    },
    onPageChange(page) {
      console.log(page);
      this.currentPage = page;
      this.loading = true;
      this.$store
        .dispatch('manageSuppliers/fetchAllSuppliers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    searchSuppliers() {
      this.currentPage = 1;
      this.loading = true;
      this.$store
        .dispatch('manageSuppliers/fetchAllSuppliers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    sortSuppliers() {
      this.loading = true;
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';

      this.$store
        .dispatch('manageSuppliers/fetchAllSuppliers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    getSuppliers() {
      this.currentPage = 1;
      this.loading = true;
      this.$store
        .dispatch('manageSuppliers/fetchAllSuppliers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    allSuppliers() {
      return this.$store.getters['manageSuppliers/allSuppliers'];
    },
    sortOrderClass() {
      return this.sortOrder === 'ASC' ? 'asc' : 'desc';
    },
    addedSupplierId() {
      return this.$store.state.manageSuppliers.addedSupplierId;
    },
  },

  mounted() {
    this.loading = true;
    this.$store
      .dispatch('manageSuppliers/fetchAllSuppliers', {
        searchTerm: this.searchTerm,
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      })
      .then(() => {
        this.loading = false;
      });
  },
  created() {
    this.setActiveMenuItem();
    this.$store.state.manageSuppliers.addedSupplierId = null;
  },
};
</script>
<style lang="scss" scoped>
.manage-suppliers {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
  .alert-warning {
    color: #c09853;
    background-color: #fcf8e3;
    border-color: #fbeed5;
  }
  .alert {
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
  }
}
.marginAll {
  margin: 10px;
  cursor: pointer;
}

html,
body {
  height: 100%;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.centered {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}
</style>
